'use client'

import { useEffect } from 'react'

import { usePathname } from 'next/navigation'
import { stripTapRef } from '@material-bank/mtag-utilities'
import { useAnalytics } from '../hooks/useAnalytics'
import { useAnalyticsContextSafe } from '../providers/AnalyticsProvider'
import { getPageConfig } from '../config/pageConfig'

export function AnalyticsPageview() {
  // On a scan landing usePathname() keeps the tap-ref (the history replace does
  // not reach Next's router). Stripping it keeps the tap-ref out of analytics,
  // and a later router sync to the clean path cannot count as a second view.
  const path = stripTapRef(usePathname())
  const { page, isReady } = useAnalytics()
  // Outside a provider there is no identity to wait for.
  const isIdentityResolved =
    useAnalyticsContextSafe()?.isIdentityResolved ?? true

  // Track page views on route change with the canonical category + name.
  useEffect(() => {
    if (!isReady || !isIdentityResolved) {
      return
    }

    const config = getPageConfig(path)
    page(config?.category, config?.name, { path })
  }, [path, isReady, isIdentityResolved, page])

  return null
}
